function getImageURL (url)
{
  // @todo use config
  return `https://firebasestorage.googleapis.com/v0/b/vallerex-ineo-prod.appspot.com/o/${encodeURIComponent(url)}?alt=media`
}

function processBatch (data, func, statusFunc)
{
  return new Promise((resolve, reject) => {
    var results    = []
    var index      = 0
    var iCompleted = 0

    const next = () => {
      if (iCompleted < data.length)
      {
        if (index < data.length)
        {
          const curIndex = index++
          const promise  = func(data[curIndex])

          promise.then(result => {
            statusFunc(curIndex, data.length, result)

            results.push(result)

            ++iCompleted
            next()
          }, err => {

            ++iCompleted
            next()

          })
        }
      } else
      {
        resolve(results)
      }
    }

    // start first iteration
    next()
    next()
    next()
    next()
    next()
    next()
    next()
    next()
    next()
    next()
    next()
    next()
  })
}

export {
  getImageURL,
  processBatch,
}
